import { Pipe, PipeTransform } from '@angular/core';
import { AppState } from '../app.service';
@Pipe({
    name: 'pqPathUpdate',
    standalone: false
})
export class PathUpdatePipe implements PipeTransform {
  constructor (
    private _appState: AppState
  ) {}
  
  transform (value: string): string {
    const moniker = this._appState.get('current_profile');
    const path = 'https://s3.amazonaws.com/pq-static-content-preprod-us-east-1/resources/' + moniker;
    return value.replace('[docpath]', path);
  }
}
